import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedMaterialModule } from './shared-material.module';
import { DeactivateDialogComponent } from './components/deactivate-dialog/deactivate-dialog.component';
import { OrderTranslatePipe } from './pipes/order-translate.pipe';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from './components/breadcrumb/breadcrumbs.component';
import { SharedSnackbarComponent } from './components/snackbar/snackbar.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MessageIconComponent } from './components/message-icon/message-icon.component';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ConfirmDialogComponent,
    DeactivateDialogComponent,
    HeaderComponent,
    SharedSnackbarComponent,
    OrderTranslatePipe,
    MessageIconComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, SharedMaterialModule],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedMaterialModule,
    BreadcrumbsComponent,
    ConfirmDialogComponent,
    DeactivateDialogComponent,
    HeaderComponent,
    SharedSnackbarComponent,
    OrderTranslatePipe,
    MessageIconComponent
  ]
})
export class SharedModule {}
